export default __webpack_public_path__ + "static/media/entreo-cirkels.27ccdfea.svg";